export const enrollRoutes = {
  INFO: 'info',
  QUALIFICATION: 'qualification',
  NO_ELIGIBLE: 'no-eligible',
  PLANS: 'plans',
  PLAN: 'plans/:planId',
  PLANS_COMPARE: 'plans/compare',
  PLAN_RANK: 'rank',
  MEMBER_DETAILS: 'details',
  FINALIZE: 'finalize',
  SUCCESS: 'success'
}

const routes = {
  ROOT: '/',
  STATE_NOT_ALLOWED: '/state-not-allowed',
  WELCOME_BACK: '/welcome-back',
  ENROLL: '/enroll',
  ENROLL_INFO: `/enroll/${enrollRoutes.INFO}`,
  ENROLL_QUALIFICATION: `/enroll/${enrollRoutes.QUALIFICATION}`,
  ENROLL_NO_ELIGIBLE: `/enroll/${enrollRoutes.NO_ELIGIBLE}`,
  ENROLL_PLAN_RANK: `/enroll/${enrollRoutes.PLAN_RANK}`,
  ENROLL_RANK: `/enroll/${enrollRoutes.PLAN_RANK}`,
  ENROLL_PLANS: `/enroll/${enrollRoutes.PLANS}`,
  ENROLL_PLAN: `/enroll/${enrollRoutes.PLAN}`,
  ENROLL_COMPARE: `/enroll/${enrollRoutes.PLANS_COMPARE}`,
  ENROLL_MEMBER_DETAILS: `/enroll/${enrollRoutes.MEMBER_DETAILS}`,
  ENROLL_FINALIZE: `/enroll/${enrollRoutes.FINALIZE}`,
  ENROLL_SUCCESS: `/enroll/${enrollRoutes.SUCCESS}`
}

export default routes
